import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a9cbfb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "header-detail" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "media/icons/chevron-left-circle-bold.svg",
  style: {"width":"25px"},
  alt: ""
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "Transaction Detail")
], -1))
const _hoisted_6 = { style: {"background-color":"#ffd600"} }
const _hoisted_7 = { class: "container-invoice" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = {
  class: "d-flex",
  style: {"height":"100%","align-items":"center"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"font-weight":"bolder"} }, "WESERVE", -1))
const _hoisted_11 = { class: "container-invoice" }
const _hoisted_12 = { class: "topic-title" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-right":"2vw"} }, [
  /*#__PURE__*/_createElementVNode("h4", null, "ผู้ออก")
], -1))
const _hoisted_14 = { style: {"margin-left":"2vw","margin-top":"2vh"} }
const _hoisted_15 = {
  class: "title2",
  style: {"height":"12vh"}
}
const _hoisted_16 = { style: {"display":"flex","align-items":"center","height":"10vh"} }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { style: {"margin-right":"2vw"} }, [
    /*#__PURE__*/_createElementVNode("h4", null, "ลูกค้า")
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"margin-right":"2vw"} }, [
    /*#__PURE__*/_createElementVNode("h4", null, "ที่อยู่")
  ])
], -1))
const _hoisted_18 = { style: {"margin-left":"6vw"} }
const _hoisted_19 = { style: {"font-weight":"20"} }
const _hoisted_20 = { style: {"font-weight":"20"} }
const _hoisted_21 = { style: {"display":"flex","margin-top":"1.5vh"} }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-right":"2vw"} }, [
  /*#__PURE__*/_createElementVNode("h4", null, "เลขที่ใบกำกับ"),
  /*#__PURE__*/_createElementVNode("h4", null, "วันที่ออก"),
  /*#__PURE__*/_createElementVNode("h4", null, "ครบกำหนด")
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title2",
  style: {"height":"5.5vh"}
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "d-flex",
    style: {"width":"28vw","justify-content":"space-between"}
  }, [
    /*#__PURE__*/_createElementVNode("p", null, "ลำดับที่"),
    /*#__PURE__*/_createElementVNode("p", null, "รายละเอียด")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", null, "จำนวนเงิน")
  ])
], -1))
const _hoisted_24 = {
  class: "titleloop",
  style: {"height":"100%"}
}
const _hoisted_25 = { style: {"width":"5vw","margin-top":"1vw"} }
const _hoisted_26 = { style: {"width":"15vw","margin-top":"1vw"} }
const _hoisted_27 = { style: {"width":"7vw","margin-top":"1vw"} }
const _hoisted_28 = { style: {"margin-left":"4vw"} }
const _hoisted_29 = { class: "title2-noboder" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "หมายเหตุ")
], -1))
const _hoisted_31 = {
  class: "d-flex",
  style: {"width":"20vw","justify-content":"space-between"}
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "จำนวนเงินรวมทั้งสิ้น", -1))
const _hoisted_33 = { class: "d-flex" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "ตัวอักษร:", -1))
const _hoisted_35 = {
  key: 1,
  class: "card-two"
}
const _hoisted_36 = { class: "header-detail-2" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "media/icons/chevron-left-circle-bold.svg",
  style: {"width":"25px"},
  alt: ""
}, null, -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-left":"25vw"} }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Transaction Detail")
], -1))
const _hoisted_40 = { style: {"background-color":"#ffd600"} }
const _hoisted_41 = { class: "container-invoice" }
const _hoisted_42 = { class: "title" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "ใบแจ้งหนี้/ใบวางบิล")
], -1))
const _hoisted_44 = {
  class: "d-flex",
  style: {"height":"100%","align-items":"center"}
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"font-weight":"bolder"} }, "WESERVE", -1))
const _hoisted_46 = { class: "container-invoice" }
const _hoisted_47 = {
  class: "topic-title",
  style: {"justify-content":"space-between"}
}
const _hoisted_48 = {
  class: "d-flex",
  style: {"margin-top":"2vh"}
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-right":"2vw"} }, [
  /*#__PURE__*/_createElementVNode("h4", null, "ผู้ออก")
], -1))
const _hoisted_50 = {
  class: "d-flex",
  style: {"margin-right":"5vw"}
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { style: {"margin-right":"1vw"} }, "เลขประจำตัวผู้เสียภาษี", -1))
const _hoisted_52 = { class: "title2" }
const _hoisted_53 = {
  class: "d-flex",
  style: {"justify-content":"space-between","width":"35vw","height":"10vh","align-items":"center"}
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "ลูกค้า"),
  /*#__PURE__*/_createElementVNode("h4", null, "ที่อยู่"),
  /*#__PURE__*/_createElementVNode("h4", null, "เลขประจำตัวผู้เสียภาษี")
], -1))
const _hoisted_55 = { class: "text-detail" }
const _hoisted_56 = { style: {"display":"flex","margin-top":"1.5vh","margin-right":"4vw","width":"15vw"} }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-right":"2vw"} }, [
  /*#__PURE__*/_createElementVNode("h4", null, "เลขที่ใบกำกับ"),
  /*#__PURE__*/_createElementVNode("h4", null, "วันที่ออก"),
  /*#__PURE__*/_createElementVNode("h4", null, "ครบกำหนด")
], -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title2",
  style: {"height":"5.5vh","align-items":"center"}
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "d-flex",
    style: {"width":"25vw","justify-content":"space-between"}
  }, [
    /*#__PURE__*/_createElementVNode("p", null, "ลำดับที่"),
    /*#__PURE__*/_createElementVNode("p", null, "รายละเอียด")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", null, "จำนวน")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", null, "หน่วยละ")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", null, "ส่วนลด")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", null, "จำนวนเงิน")
  ])
], -1))
const _hoisted_59 = {
  class: "",
  style: {"border-bottom":"1px solid #00000029","justify-content":"start"}
}
const _hoisted_60 = { style: {"width":"5vw","margin-left":"1vw","margin-top":"1vw"} }
const _hoisted_61 = { style: {"width":"15vw","margin-top":"1vw"} }
const _hoisted_62 = { style: {"width":"7vw","margin-top":"1vw"} }
const _hoisted_63 = { style: {"margin-left":"6vw"} }
const _hoisted_64 = { style: {"width":"7vw","margin-top":"1vw"} }
const _hoisted_65 = { style: {"margin-left":"4vw"} }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { style: {"margin-left":"4vw","margin-top":"1vw"} }, "0.0", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-right":"3vw","margin-top":"1vw"} }, null, -1))
const _hoisted_68 = { style: {"margin-top":"1vw","margin-bottom":"1vh"} }
const _hoisted_69 = { class: "title2-noboder" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "หมายเหตุ")
], -1))
const _hoisted_71 = {
  class: "d-flex",
  style: {"margin-top":"17vh"}
}
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "ตัวอักษร:", -1))
const _hoisted_73 = { class: "d-flex" }
const _hoisted_74 = /*#__PURE__*/_createStaticVNode("<div data-v-1a9cbfb4><div style=\"width:10vw;display:flex;justify-content:flex-end;\" data-v-1a9cbfb4><p data-v-1a9cbfb4>รวมเป็นเงิน</p></div><div style=\"width:10vw;display:flex;justify-content:flex-end;\" data-v-1a9cbfb4><p data-v-1a9cbfb4>หัก ส่วนลด</p></div><div style=\"width:10vw;display:flex;justify-content:flex-end;\" data-v-1a9cbfb4><p data-v-1a9cbfb4>ยอดหลังหักส่วนลด</p></div><div style=\"width:10vw;display:flex;justify-content:flex-end;\" data-v-1a9cbfb4><p data-v-1a9cbfb4>หัก เงินมัดจำ</p></div><div style=\"width:10vw;display:flex;justify-content:flex-end;\" data-v-1a9cbfb4><p data-v-1a9cbfb4>จำนวนเงินหลังหักมัดจำ</p></div><div style=\"width:10vw;display:flex;justify-content:flex-end;\" data-v-1a9cbfb4><p data-v-1a9cbfb4>จำนวนภาษีมูลค่าเพิ่ม 7%</p></div><div style=\"width:10vw;display:flex;justify-content:flex-end;\" data-v-1a9cbfb4><p data-v-1a9cbfb4>จำนวนเงินรวมทั้งสิ้น</p></div></div>", 1)
const _hoisted_75 = { style: {"width":"10vw","display":"flex","justify-content":"flex-end"} }
const _hoisted_76 = { style: {"width":"10vw","display":"flex","justify-content":"flex-end"} }
const _hoisted_77 = { style: {"width":"10vw","display":"flex","justify-content":"flex-end"} }
const _hoisted_78 = { style: {"width":"10vw","display":"flex","justify-content":"flex-end"} }
const _hoisted_79 = { style: {"width":"10vw","display":"flex","justify-content":"flex-end"} }
const _hoisted_80 = { style: {"width":"10vw","display":"flex","justify-content":"flex-end"} }
const _hoisted_81 = { style: {"width":"10vw","display":"flex","justify-content":"flex-end"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", null, [
    (
        _ctx.walletTransactionInvoice.bill_type.bill_type_name ===
        `ใบแจ้งชำระหนี้ของ rider`
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _createElementVNode("span", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.back())),
                class: "btn btn-active-white",
                style: {"position":"absolute","left":"0px","top":"15px"}
              }, _hoisted_4)
            ]),
            _hoisted_5
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", null, [
                  _createElementVNode("h1", null, _toDisplayString(_ctx.walletTransactionInvoice.bill_type.bill_type_name), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_inline_svg, {
                    src: "media/icons/monky.svg",
                    style: {"width":"3vw","height":"3vw"}
                  }),
                  _hoisted_10
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("p", null, _toDisplayString(_ctx.walletTransactionInvoice.bill_issuer_name), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.walletTransactionInvoice.bill_issuer_address), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("h5", _hoisted_19, _toDisplayString(_ctx.walletTransactionInvoice.bill_customer_name), 1),
                  _createElementVNode("h5", _hoisted_20, _toDisplayString(_ctx.walletTransactionInvoice.bill_customer_address), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", null, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.walletTransactionInvoice.bill_number), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.moment(_ctx.walletTransactionInvoice.created_at).format(
                    "DD-MM-YYYY"
                  )), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.moment(_ctx.walletTransactionInvoice.bill_due_date).format(
                    "DD-MM-YYYY"
                  )), 1)
                ])
              ])
            ]),
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.walletTransactionInvoice.bill_detail, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "d-flex",
                  style: {"justify-content":"space-between"}
                }, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("a", null, _toDisplayString(index + 1), 1)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("a", null, _toDisplayString(item.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("a", _hoisted_28, _toDisplayString(item.price), 1)
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("h4", null, _toDisplayString(_ctx.walletTransactionInvoice.bill_amount_price), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _createElementVNode("a", null, _toDisplayString(`(${_ctx.walletTransactionInvoice.bill_net_price_text})`), 1)
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("span", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.back())),
              class: "btn btn-active-white"
            }, _hoisted_38),
            _hoisted_39
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                _createElementVNode("div", _hoisted_44, [
                  _createVNode(_component_inline_svg, {
                    src: "media/icons/monky.svg",
                    style: {"width":"3vw","height":"3vw"}
                  }),
                  _hoisted_45
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _hoisted_49,
                _createElementVNode("div", null, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.walletTransactionInvoice.bill_issuer_name), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.walletTransactionInvoice.bill_issuer_address), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _hoisted_51,
                _createElementVNode("p", null, _toDisplayString(_ctx.walletTransactionInvoice.bill_issuer_tax_id), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", _hoisted_53, [
                _hoisted_54,
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("h5", null, _toDisplayString(_ctx.walletTransactionInvoice.bill_customer_name), 1),
                  _createElementVNode("h5", null, _toDisplayString(_ctx.walletTransactionInvoice.bill_customer_address), 1),
                  _createElementVNode("h5", null, _toDisplayString(_ctx.walletTransactionInvoice.bill_customer_tax_id), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_56, [
                _hoisted_57,
                _createElementVNode("div", null, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.walletTransactionInvoice.bill_number), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.moment(_ctx.walletTransactionInvoice.created_at).format(
                    "DD-MM-YYYY"
                  )), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.moment(_ctx.walletTransactionInvoice.bill_due_date).format(
                    "DD-MM-YYYY"
                  )), 1)
                ])
              ])
            ]),
            _hoisted_58,
            _createElementVNode("div", _hoisted_59, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.walletTransactionInvoice.bill_detail, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "d-flex",
                  style: {"justify-content":"space-between"}
                }, [
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("a", null, _toDisplayString(index + 1), 1)
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("a", null, _toDisplayString(item.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("a", _hoisted_63, _toDisplayString(item.unit), 1)
                  ]),
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("a", _hoisted_65, _toDisplayString(item.price), 1)
                  ]),
                  _hoisted_66,
                  _hoisted_67,
                  _createElementVNode("a", _hoisted_68, _toDisplayString(item.price * item.unit), 1)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_69, [
              _createElementVNode("div", null, [
                _hoisted_70,
                _createElementVNode("div", _hoisted_71, [
                  _hoisted_72,
                  _createElementVNode("a", null, _toDisplayString(`(${_ctx.walletTransactionInvoice.bill_net_price_text})`), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_73, [
                _hoisted_74,
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_75, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.walletTransactionInvoice.bill_amount_price), 1)
                  ]),
                  _createElementVNode("div", _hoisted_76, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.walletTransactionInvoice.bill_discount_price), 1)
                  ]),
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.walletTransactionInvoice.bill_amount_price -
                    _ctx.walletTransactionInvoice.bill_discount_price), 1)
                  ]),
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.walletTransactionInvoice.bill_deposit_price), 1)
                  ]),
                  _createElementVNode("div", _hoisted_79, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.walletTransactionInvoice.bill_amount_price -
                    _ctx.walletTransactionInvoice.bill_discount_price -
                    _ctx.walletTransactionInvoice.bill_deposit_price), 1)
                  ]),
                  _createElementVNode("div", _hoisted_80, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.walletTransactionInvoice.bill_vat_price), 1)
                  ]),
                  _createElementVNode("div", _hoisted_81, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.walletTransactionInvoice.bill_net_price), 1)
                  ])
                ])
              ])
            ])
          ])
        ]))
  ]))
}